var TiaraTracker = (function () {
  'use strict';

  /* global window, process */
  /* eslint global-require: "off" */

  var isDev = 'production' !== 'production';
  var W = window;
  if ('undefined' !== typeof document.cookie) {
    document.cookie = ['__T_=1; ', 'domain=', location.hostname].join('');
  }

  function getTz() {
    var minutes = new Date().getTimezoneOffset();
    return [minutes < 0 ? '+' : '', (minutes / 60) * -1].join('');
  }

  function isContain(str, searchValue) {
    return str.indexOf(searchValue) > -1;
  }

  function isCookieEnabled() {
    if (W.navigator.cookieEnabled) {
      if ('undefined' !== typeof document.cookie) {
        return document.cookie.indexOf('__T_=1') !== -1 ? true : false;
      }
    }
    return W.navigator.cookieEnabled;
  }

  var TRACK_URL_K = 'https://stat.tiara.kakao.com/track';
  var TRACK_URL_D = 'https://stat.tiara.daum.net/track';
  var TRACK_URL_M = 'https://stat.tiara.melon.com/track';
  var TRACK_URL_B = 'https://stat.tiara.brunch.co.kr/track';
  var TRACK_URL_T = 'https://stat.tiara.tistory.com/track';
  var TRACK_URL_F = 'https://stat.tiara.kakaofriends.com/track';
  var TRACK_URL_KC = 'https://stat.tiara.kakaocorp.com/track';
  var TRACK_URL_P = 'https://stat.tiara.kakaopay.com/track';
  var TRACK_URL_H = 'https://stat.tiara.kakaohairshop.co.kr/track';
  var TRACK_URL_KM = 'https://stat.tiara.kakaomobility.com/track';

  var ua = W.navigator.userAgent.toString().toLowerCase();
  var isIOs = /ipad|iphone|ipod/.test(ua);
  var isKakao =
    isContain(W.location.hostname, '.kakao.com') ||
    (isContain(ua, 'kakaotalk') && !isIOs);
  var isDaum = isContain(W.location.hostname, '.daum.net');
  var isMelon = isContain(W.location.hostname, 'melon.com');
  var isBrunch = isContain(W.location.hostname, 'brunch.co.kr');
  var isTistory = isContain(W.location.hostname, 'tistory.com');
  var isKakaoFriends = isContain(W.location.hostname, 'kakaofriends.com');
  var isKakaoCorp = isContain(W.location.hostname, 'kakaocorp.com');
  var isKakaoPay = isContain(W.location.hostname, 'kakaopay.com');
  var isKakaoHairshop = isContain(W.location.hostname, 'kakaohairshop.co.kr');
  var isKakaoMobility = isContain(W.location.hostname, 'kakaomobility.com');
  var isSamsungBrowser = isContain(ua, 'samsungbrowser');
  var cookieEnabled = isCookieEnabled();
  var versionSuffix = '';
  var version = '1.1.16';

  function getTrackUrl() {
    var host = TRACK_URL_D;
    if (isKakao) {
      host = TRACK_URL_K;
    } else if (isDaum) {
      host = TRACK_URL_D;
    } else if (isMelon) {
      host = TRACK_URL_M;
    } else if (isBrunch) {
      host = TRACK_URL_B;
    } else if (isTistory) {
      host = TRACK_URL_T;
    } else if (isKakaoFriends) {
      host = TRACK_URL_F;
    } else if (isKakaoCorp) {
      host = TRACK_URL_KC;
    } else if (isKakaoPay) {
      host = TRACK_URL_P;
    } else if (isKakaoHairshop) {
      host = TRACK_URL_H;
    } else if (isKakaoMobility) {
      host = TRACK_URL_KM;
    }
    return host;
  }

  var defaults = {
    page: 'default',
    title: W.document.title,
    screen: W.screen.width + 'X' + W.screen.height,
    tz: getTz(),
    cke: cookieEnabled ? 'Y' : 'N',
    trackUrl:
      process.env.REGION === 'kor' || window.localStorage['logviewer'] === 'Y'
        ? getTrackUrl()
        : process.env.TRACK_URL, // for kakaowebtoon
    deployment: isDev ? 'dev' : 'production',
    sessionTimeout: '1800',
    version: version + versionSuffix,
    type: 'WEB',
  };

  var isBelowIe7 = isContain(ua, 'msie 7') || isContain(ua, 'msie 6');

  /* global Image */

  /**
   * use img element
   * @param {string} url
   */
  function imageRequest(url) {
    // ie7 이하인 경우 2030 넘을 경우 전송 불가
    if (isBelowIe7 && url.length > 2030) {
      return;
    }

    var img = new Image(1, 1);

    img.onload = img.onerror = function imageLoaded() {
      img.onload = null;
      img.onerror = null;
    };

    img.src = url;
  }

  /* global window */
  /**
   * xhr
   * @param {string} trackUrl
   * @param {string} qs
   * @return {boolean}
   */
  function xmlHttpRequest(trackUrl, qs) {
    if (!window.XMLHttpRequest) {
      return false;
    }

    var xhr = new window.XMLHttpRequest();
    if (!('withCredentials' in xhr)) {
      return false;
    }

    xhr.open('POST', trackUrl, true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'text/plain');
    xhr.send(qs);

    return true;
  }

  var _typeof =
    typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
      ? function (obj) {
          return typeof obj;
        }
      : function (obj) {
          return obj &&
            typeof Symbol === 'function' &&
            obj.constructor === Symbol &&
            obj !== Symbol.prototype
            ? 'symbol'
            : typeof obj;
        };

  /*
    eslint
    no-useless-escape: "off",
    guard-for-in: "off",
    no-restricted-syntax: "off",
    no-param-reassign: "off"
   */

  /**
   * Array.isArray() polyfill
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
   */
  if (!Array.isArray) {
    Array.isArray = function (arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  function subString(url, searchValue) {
    var index = url.indexOf(searchValue);
    return index === -1 ? url : url.substring(0, index);
  }

  function parseUri(url) {
    var o = {
      strictMode: false,
      key: [
        'source',
        'protocol',
        'authority',
        'userInfo',
        'user',
        'password',
        'host',
        'port',
        'relative',
        'path',
        'directory',
        'file',
        'query',
        'anchor',
      ],
      q: {
        name: 'queryKey',
        parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
      },
      parser: {
        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
      },
    };
    var m = o.parser['loose'].exec(url);
    var uri = {};

    var i = 14;

    while (i > 0) {
      i -= 1;
      uri[o.key[i]] = m[i] || '';
    }

    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
      if ($1) uri[o.q.name][$1] = $2;
    });

    return uri;
  }

  function removeQueryParams(url, queryParams) {
    var ignoreQueryParams = queryParams.join('|');
    var urlObj = parseUri(url);
    var resultUrl = url;
    if (urlObj.query) {
      var queryString = '&' + urlObj.query;
      var pattern = '(^|&)(' + ignoreQueryParams + ')=[^&#]*';
      var regExp = new RegExp(pattern, 'g');
      queryString = queryString.replace(regExp, '').substring(1);
      if (queryString && queryString.length > 0) {
        queryString = '?' + queryString;
      }

      var newUrl = [];

      newUrl.push(urlObj.protocol + '://');
      newUrl.push(urlObj.authority);
      newUrl.push(urlObj.path);
      newUrl.push(queryString);
      if (urlObj.anchor && urlObj.anchor.length > 0) {
        newUrl.push('#' + urlObj.anchor);
      }
      resultUrl = newUrl.join('');
    }

    return resultUrl;
  }

  function mixin(obj1, obj2) {
    for (var attr in obj2) {
      obj1[attr] = obj2[attr];
    }
    return obj1;
  }

  function getCookie(name) {
    var ckName = name + '=';
    var cookie = document.cookie;
    if (cookie) {
      var start = cookie.indexOf(ckName);
      var end = void 0;
      if (start !== -1) {
        start += ckName.length;
        end = cookie.indexOf(';', start);
        if (end === -1) {
          end = cookie.length;
        }
        return cookie.substring(start, end);
      }
    }
    return null;
  }

  /**
   * /**
   * jQuery 3.0 구현 참고
   * @see https://github.com/jquery/jquery/blob/c18d608537d8945de6c5855a9475657177fa74ac/src/core.js#L224
   * @param obj
   * @returns {boolean}
   */
  function isNumeric(obj) {
    return (
      (typeof obj === 'number' || typeof obj === 'string') &&
      !isNaN(obj - parseFloat(obj))
    );
  }

  /**
   *
   * @param obj
   */
  function isEmptyObject(obj) {
    var isEmpty = true;
    if (
      (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object'
    ) {
      var cnt = 0;
      for (var key in obj) {
        if (cnt > 0) {
          break;
        }
        cnt++;
      }

      if (cnt > 0) {
        isEmpty = false;
      }
    }
    return isEmpty;
  }

  /* eslint-disable */
  /**
   * json2
   * ie6 에서 json stringify를 하기 위해서 json2 에서 stringify 메소드만 가져옴
   * https://github.com/douglascrockford/JSON-js
   */

  var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

  var gap = void 0;
  var indent = void 0;
  var meta = void 0;
  var rep = void 0;

  function quote(string) {
    rx_escapable.lastIndex = 0;
    return rx_escapable.test(string)
      ? '"' +
          string.replace(rx_escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string'
              ? c
              : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
          }) +
          '"'
      : '"' + string + '"';
  }

  function str(key, holder) {
    var i = void 0; // The loop counter.
    var k = void 0; // The member key.
    var v = void 0; // The member value.
    var length = void 0;
    var mind = gap;
    var partial = void 0;
    var value = holder[key];

    if (
      value &&
      (typeof value === 'undefined' ? 'undefined' : _typeof(value)) ===
        'object' &&
      typeof value.toJSON === 'function'
    ) {
      value = value.toJSON(key);
    }

    if (typeof rep === 'function') {
      value = rep.call(holder, key, value);
    }

    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'string':
        return quote(value);

      case 'number':
        return isFinite(value) ? String(value) : 'null';

      case 'boolean':
      case 'null':
        return String(value);

      case 'object':
        if (!value) {
          return 'null';
        }

        gap += indent;
        partial = [];

        if (Object.prototype.toString.apply(value) === '[object Array]') {
          length = value.length;
          for (i = 0; i < length; i += 1) {
            partial[i] = str(i, value) || 'null';
          }

          v =
            partial.length === 0
              ? '[]'
              : gap
              ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
              : '[' + partial.join(',') + ']';
          gap = mind;
          return v;
        }

        if (
          rep &&
          (typeof rep === 'undefined' ? 'undefined' : _typeof(rep)) === 'object'
        ) {
          length = rep.length;
          for (i = 0; i < length; i += 1) {
            if (typeof rep[i] === 'string') {
              k = rep[i];
              v = str(k, value);
              if (v) {
                partial.push(quote(k) + (gap ? ': ' : ':') + v);
              }
            }
          }
        } else {
          for (k in value) {
            if (Object.prototype.hasOwnProperty.call(value, k)) {
              v = str(k, value);
              if (v) {
                partial.push(quote(k) + (gap ? ': ' : ':') + v);
              }
            }
          }
        }

        v =
          partial.length === 0
            ? '{}'
            : gap
            ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
            : '{' + partial.join(',') + '}';
        gap = mind;
        return v;
    }
  }

  meta = {
    // table of character substitutions
    '\b': '\\b',
    '\t': '\\t',
    '\n': '\\n',
    '\f': '\\f',
    '\r': '\\r',
    '"': '\\"',
    '\\': '\\\\',
  };

  var json2Stringify = function json2Stringify(value, replacer, space) {
    var i = void 0;
    gap = '';
    indent = '';

    if (typeof space === 'number') {
      for (i = 0; i < space; i += 1) {
        indent += ' ';
      }
    } else if (typeof space === 'string') {
      indent = space;
    }

    rep = replacer;
    if (
      replacer &&
      typeof replacer !== 'function' &&
      ((typeof replacer === 'undefined' ? 'undefined' : _typeof(replacer)) !==
        'object' ||
        typeof replacer.length !== 'number')
    ) {
      throw new Error('JSON.stringify');
    }

    return str('', { '': value });
  };

  /* global window */

  // constants
  var PROPS = {
    ACCESS_TOKEN: 'accessToken',
    APP_USER_ID: 'appUserId',
    KAKAO_APP_KEY: 'kakaoAppKey',
    SESSION_TIMEOUT: 'sessionTimeout',
    SVC_DOMAIN: 'svcdomain',
    DEPLOYMENT: 'deployment',
    URL: 'url',
    REFERRER: 'referrer',
    TITLE: 'title',
    SECTION: 'section',
    PAGE: 'page',
    PAGE_META: 'pageMeta',
    AD_TRACK_ID: 'adTrackId',
    TRACK_URL: 'trackUrl',
    THIRD_PROVIDE_AGREE: 'thirdProvideAgree',
    THIRD_AD_AGREE: 'thirdAdAgree',
    USER_EX_ACCOUNT: 'userExAccount',
    USER_EX_ANONYMOUS: 'userExAnonymous',
    TUID: 'tuid',
    TSID: 'tsid',
    UUID: 'uuid',
    SUID: 'suid',
  };

  /**
   * window.JSON 이 없는 경우 json2Stringify 를 사용한다
   * @param {String} str
   */
  function jsonStringify(str) {
    if (window.JSON) {
      return JSON.stringify(str);
    }
    return json2Stringify(str);
  }

  var Requester = {
    /**
     * query string length 에 따라서 imageRequest 를 사용하거나 xmlHttpRequest 를 사용한다.
     * @param {string} trackUrl
     * @param {string} qs
     * @param {boolean} enableAlwaysHttpPost
     * @param {boolean} enableAlwaysImage
     * @private
     */
    _adapter: function _adapter(
      trackUrl,
      qs,
      enableAlwaysHttpPost,
      enableAlwaysImage,
    ) {
      var _qs = jsonStringify(qs);
      var url = trackUrl + '?d=' + encodeURIComponent(_qs);

      if (enableAlwaysHttpPost) {
        xmlHttpRequest(trackUrl, _qs);
      } else if (enableAlwaysImage) {
        imageRequest(url);
      } else if (url.length <= 2030) {
        imageRequest(url);
      } else {
        xmlHttpRequest(trackUrl, _qs) || imageRequest(url);
      }
    },

    /**
     * request
     * @param tiara
     */
    send: function send(tiara) {
      var elements = tiara._elements;
      var type = defaults.type,
        version = defaults.version,
        screen = defaults.screen,
        tz = defaults.tz,
        cke = defaults.cke;

      var commonProps = {
        sdk: {
          type: type,
          version: version,
        },
        env: {
          screen: screen,
          tz: tz,
          cke: cke,
        },
      };

      // common
      var common = {};
      var commonMap = [
        { set: 'session_timeout', get: PROPS.SESSION_TIMEOUT },
        { set: 'svcdomain', get: PROPS.SVC_DOMAIN },
        { set: 'deployment', get: PROPS.DEPLOYMENT },
        { set: 'url', get: PROPS.URL },
        { set: 'referrer', get: PROPS.REFERRER },
        { set: 'title', get: PROPS.TITLE },
        { set: 'section', get: PROPS.SECTION },
        { set: 'page', get: PROPS.PAGE },
        { set: 'ad_track_id', get: PROPS.AD_TRACK_ID },
        { set: 'kakao_app_key', get: PROPS.KAKAO_APP_KEY },
        { set: 'third_provide_agree', get: PROPS.THIRD_PROVIDE_AGREE },
        { set: 'third_ad_agree', get: PROPS.THIRD_AD_AGREE },
      ];
      for (var i = 0; i < commonMap.length; i++) {
        if (tiara._getProperty(commonMap[i].get)) {
          common[commonMap[i].set] = tiara._getProperty(commonMap[i].get);
        }
      }
      if (!isEmptyObject(common)) {
        commonProps['common'] = common;
      }

      // user
      var user = {};
      var userMap = [
        { set: 'access_token', get: PROPS.ACCESS_TOKEN },
        { set: 'app_user_id', get: PROPS.APP_USER_ID },
      ];
      for (var _i = 0; _i < userMap.length; _i++) {
        if (tiara._getProperty(userMap[_i].get)) {
          user[userMap[_i].set] = tiara._getProperty(userMap[_i].get);
        }
      }
      if (!isEmptyObject(user)) {
        commonProps['user'] = user;
      }

      // page_meta
      if (tiara._getProperty(PROPS.PAGE_META)) {
        commonProps['page_meta'] = tiara._getProperty(PROPS.PAGE_META);
      }

      // user_ex_acount
      if (tiara._getProperty(PROPS.USER_EX_ACCOUNT)) {
        commonProps['user_ex_account'] = tiara._getProperty(
          PROPS.USER_EX_ACCOUNT,
        );
      }

      // user_ex_anonymous
      if (tiara._getProperty(PROPS.USER_EX_ANONYMOUS)) {
        commonProps['user_ex_anonymous'] = tiara._getProperty(
          PROPS.USER_EX_ANONYMOUS,
        );
      }

      // tuid/tsid & uuid/suid
      var etc = {
        client_info: {},
      };

      var clientInfoMap = [
        { set: 'tuid', get: PROPS.TUID },
        { set: 'tsid', get: PROPS.TSID },
        { set: 'uuid', get: PROPS.UUID },
        { set: 'suid', get: PROPS.SUID },
      ];

      for (var _i2 = 0; _i2 < clientInfoMap.length; _i2++) {
        if (tiara._getProperty(clientInfoMap[_i2].get)) {
          etc['client_info'][clientInfoMap[_i2].set] = tiara._getProperty(
            clientInfoMap[_i2].get,
          );
        }
      }
      if (!isEmptyObject(etc['client_info'])) {
        commonProps['etc'] = etc;
      }

      // action
      var actionProps = {};
      for (var _i3 = 0; _i3 < elements.length; _i3++) {
        var prop = elements[_i3];
        if (tiara._getActionProperty(prop)) {
          actionProps[prop] = tiara._getActionProperty(prop);
        }
      }

      var qs = mixin(commonProps, actionProps);
      var trackUrl = tiara._getProperty(PROPS.TRACK_URL);

      this._adapter(
        trackUrl,
        qs,
        tiara._enableAlwaysHttpPost,
        tiara._enableAlwaysImage,
      );
    },
  };

  var CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  var IDGenerator = {
    generateRandomUUIDWithDateTime: function generateRandomUUIDWithDateTime() {
      var uuidArray = ['w-'];
      uuidArray.push(this.shortenID(12));
      uuidArray.push('_');
      uuidArray.push(this.currentTimeStamp());
      return uuidArray.join('');
    },

    // UUID, SUID는 기존 TUID, TSID와는 다른 포맷으로 가져감.
    generateRandomUUIDWithDateNumber: function generateRandomUUIDWithDateNumber() {
      var uuidArray = ['w-'];
      uuidArray.push(this.shortenID(12));
      uuidArray.push('_');
      //yyMMdd
      uuidArray.push(this.currentTimeStamp().substring(0, 6));
      uuidArray.push(this.randomNumericString(9));
      return uuidArray.join('');
    },
    currentTimeStamp: function currentTimeStamp() {
      var today = new Date();
      today.setHours(today.getHours() + 9);
      // yyMMddHHmmssSSS format
      return today
        .toISOString()
        .replace(/T|Z|-|:|\./g, '')
        .substring(2);
    },
    randomNumericString: function randomNumericString(length) {
      var randomString = [];
      for (var i = 0; i < length; i++) {
        var random = Math.floor(Math.random() * 10);
        randomString.push(random);
      }
      return randomString.join('');
    },
    shortenID: function shortenID(length) {
      var shortID = [];
      for (var i = 0; i < length; i++) {
        var random = CHARS[Math.floor(Math.random() * CHARS.length)];
        shortID.push(random);
      }
      return shortID.join('');
    },
  };

  function isIgnoreClickButtonClick(event) {
    if ('number' === typeof event.which) {
      if (event.which === 2) {
        return true;
      }
      if (event.which === 3) {
        return true;
      }
    } else if ('number' === typeof event.button) {
      if (event.button === 2) {
        return true;
      }
      if (event.button === 4) {
        return true;
      }
    } else {
      return true;
    }
    return false;
  }

  function getRelativeCoordinates(event, reference) {
    event = event || __w.event;
    var el = event.target || event.srcElement,
      pos = {};
    if (!window.opera && _typeof('undefined') !== event.offsetX) {
      pos = {
        x: event.offsetX,
        y: event.offsetY,
      };
      var e = el;
      while (e) {
        e.mouseX = pos.x;
        e.mouseY = pos.y;
        pos.x += e.offsetLeft;
        pos.y += e.offsetTop;
        e = e.offsetParent;
      }
    } else {
      // Use absolute coordinates
      pos = getAbsolutePosition(reference);
    }
    // Subtract distance to middle
    return {
      x: parseInt(pos.x, 10),
      y: parseInt(pos.y, 10),
    };
  }

  function getAbsolutePosition(element) {
    var r = {
      x: element.offsetLeft,
      y: element.offsetTop,
    };
    if (element.offsetParent) {
      var tmp = getAbsolutePosition(element.offsetParent);
      r.x += tmp.x;
      r.y += tmp.y;
    }
    return r;
  }

  function findClickPosition(event, click) {
    if (event) {
      if ('undefined' !== typeof event.pageX) {
        click.posx = parseInt(event.pageX, 10);
        click.posy = parseInt(event.pageY, 10);
      } else {
        var pos = getRelativeCoordinates(
          event,
          event.srcElement || event.target,
        );
        click.posx = pos.x;
        click.posy = pos.y;
      }
    }
  }

  /**
   * find pre-defined data attributes(data-tiara-*) and create a click info
   * @param node
   * @param click
   * @param search
   * @param eventMeta
   * @param customProps
   */
  function findClickInfo(node, click, search, eventMeta, customProps) {
    var layer = [],
      findsMoreLayer = true;
    var clickAttrs = {
      click_url: { has: false, data: 'data-tiara-click_url' },
      ordnum: { has: false, data: 'data-tiara-ordnum' },
      setnum: { has: false, data: 'data-tiara-setnum' },
      copy: { has: false, data: 'data-tiara-copy' },
      imp_id: { has: false, data: 'data-tiara-imp_id' },
      imp_provider: { has: false, data: 'data-tiara-imp_provider' },
      imp_type: { has: false, data: 'data-tiara-imp_type' },
      simple_ab_key: { has: false, data: 'data-tiara-simple_ab_key' },
      simple_ab_var: { has: false, data: 'data-tiara-simple_ab_var' },
    };
    var searchAttrs = {
      search_term: { has: false, data: 'data-tiara-search_term' },
      search_type: { has: false, data: 'data-tiara-search_type' },
    };
    var eventMetaAttrs = {
      id: { has: false, data: 'data-tiara-id' },
      type: { has: false, data: 'data-tiara-type' },
      content_type: { has: false, data: 'data-tiara-content_type' },
      name: { has: false, data: 'data-tiara-name' },
      series: { has: false, data: 'data-tiara-series' },
      series_id: { has: false, data: 'data-tiara-series_id' },
      category: { has: false, data: 'data-tiara-category' },
      category_id: { has: false, data: 'data-tiara-category_id' },
      provider: { has: false, data: 'data-tiara-provider' },
      provider_id: { has: false, data: 'data-tiara-provider_id' },
      author: { has: false, data: 'data-tiara-author' },
      author_id: { has: false, data: 'data-tiara-author_id' },
      image: { has: false, data: 'data-tiara-image' },
      plink: { has: false, data: 'data-tiara-plink' },
      tags: { has: false, data: 'data-tiara-tags' },
      ecommerce_yn: { has: false, data: 'data-tiara-ecommerce_yn' },
    };
    while (
      node &&
      'string' === typeof node.tagName &&
      node.tagName !== 'BODY'
    ) {
      if (node.nodeType === 1 && node.tagName !== 'FORM') {
        // layer
        if (findsMoreLayer && node.getAttribute('data-tiara-layer')) {
          var layers = node.getAttribute('data-tiara-layer').trim().split(' ');
          if (layers.length > 1) {
            // layer 정보가 1개 이상이면 더 이상 탐색하지 않고, 마지막에 reverse 하므로 거꾸로 push
            findsMoreLayer = false;
            for (var i = layers.length; i > 0; i--) {
              layer.push(layers[i - 1].toLowerCase());
            }
          } else {
            layer.push(layers[0].toLowerCase());
          }
        }

        // custom_props
        if (node.getAttribute('data-tiara-custom')) {
          var customPairs = node
            .getAttribute('data-tiara-custom')
            .trim()
            .split('&');
          for (var idx in customPairs) {
            if (Object.prototype.hasOwnProperty.call(customPairs, idx)) {
              if (customPairs[idx]) {
                var kv = customPairs[idx].split('=');
                if (kv.length == 2) {
                  customProps[kv[0]] = decodeURIComponent(kv[1]);
                }
              }
            }
          }
        }

        for (var attr in clickAttrs) {
          if (
            !clickAttrs[attr].has &&
            node.getAttribute(clickAttrs[attr].data)
          ) {
            click[attr] = node.getAttribute(clickAttrs[attr].data);
            clickAttrs[attr].has = true;
          }
        }
        for (var _attr in searchAttrs) {
          if (
            !searchAttrs[_attr].has &&
            node.getAttribute(searchAttrs[_attr].data)
          ) {
            search[_attr] = node.getAttribute(searchAttrs[_attr].data);
            searchAttrs[_attr].has = true;
          }
        }
        for (var _attr2 in eventMetaAttrs) {
          if (
            !eventMetaAttrs[_attr2].has &&
            node.getAttribute(eventMetaAttrs[_attr2].data)
          ) {
            eventMeta[_attr2] = node.getAttribute(eventMetaAttrs[_attr2].data);
            eventMetaAttrs[_attr2].has = true;
          }
        }

        // find click_url, copy by dom traverse
        if (node.tagName === 'A' || node.tagName === 'AREA') {
          if ('undefined' == typeof click.click_url) {
            click.click_url = node.href;
          }
          if ('undefined' === typeof click.copy) {
            var copy = node.innerHTML
              .replace(/\<br([^\>]+)?\>/gi, ' ')
              .replace(/(\<([^\>]+)\>|\r\n|\n|\r)/gm, ' ')
              .replace(/(\s+)/gm, ' ');
            if ('function' === typeof copy.trim) {
              copy = copy.trim();
            } else {
              copy = copy.replace(/^\s+|\s+$|/gm, '');
            }
            click.copy = copy;
          }
          if ('undefined' === typeof click.image) {
            var img = node.getElementsByTagName('IMG')[0];
            if (img && img.src) {
              click.image = img.src;
            }
          }
        }

        // find image by dom traverse
        if (
          node.tagName === 'IMG' &&
          node.src &&
          'undefined' === typeof click.image
        ) {
          click.image = node.src || '';
        }
      }

      if (node.parentNode) {
        node = node.parentNode;
      } else {
        break;
      }
    }

    layer = layer.reverse();
    if (layer.length > 0) {
      click.layer1 = layer[0];
    }
    if (layer.length > 1) {
      click.layer2 = layer[1];
    }
    if (layer.length > 2) {
      click.layer3 = layer[2];
    }

    // eventMeta.id가 있는데 eventMeta.name이 없으면 click.copy를 사용
    if (
      eventMeta.id &&
      eventMeta.id.length > 0 &&
      'undefined' === typeof eventMeta.name
    ) {
      eventMeta.name = click.copy;
    }
  }

  /**
   * 액션 정보 (data-tiara-action-name, data-tiara-action-kind) 추출,
   * 항목이 설정되어 있지 않을 경우 내용이 null인 action값 리턴
   * @param {Node} node
   * @return {action}
   */
  function findActionInfo(node) {
    var action = {};
    while (
      node &&
      typeof node.tagName === 'string' &&
      node.tagName !== 'BODY'
    ) {
      if (node.nodeType === 1 && node.tagName !== 'FORM') {
        if (node.hasAttribute('data-tiara-action-name')) {
          action.name = node.getAttribute('data-tiara-action-name');
          if (node.hasAttribute('data-tiara-action-kind')) {
            action.kind = node.getAttribute('data-tiara-action-kind');
          }
          break;
        }
      }
      if (node.parentNode) {
        node = node.parentNode;
      } else {
        break;
      }
    }
    return action;
  }

  var TiaraDomParser = {
    /**
     * 클릭 이벤트가 발생한 요소의 dom traverse를 통해서 데이터 반환
     * 무시해야 할 클릭 버튼이거나, 자동 클릭 항목이 설정되어있지 않을 경우 null 반환
     * @param {Event} event
     * @returns {action, click, search, eventMeta, customProps}
     */
    getClickInfo: function getClickInfo(event) {
      var evt = event || window.event,
        node = evt.srcElement || evt.target;
      var click = {},
        search = {},
        eventMeta = {},
        customProps = {};

      if (isIgnoreClickButtonClick(evt)) {
        return undefined;
      }

      var action = findActionInfo(node);
      findClickPosition(evt, click);
      findClickInfo(node, click, search, eventMeta, customProps);
      return {
        action: action,
        click: click,
        search: search,
        eventMeta: eventMeta,
        customProps: customProps,
      };
    },
  };

  var TiaraTrackerCommon = {
    /**
     * @param {string} svcdomain
     * @return {TiaraTracker}
     */
    setSvcDomain: function setSvcDomain(svcdomain) {
      if (!cookieEnabled) {
        return this;
      }

      this._svcdomain = svcdomain;
      return this;
    },

    /**
     * @param {string} url
     * @return {TiaraTracker}
     */
    setUrl: function setUrl(url) {
      this._url = url;
      return this;
    },

    /**
     * @param {string} referrer
     * @return {TiaraTracker}
     */
    setReferrer: function setReferrer(referrer) {
      this._referrer = referrer;
      return this;
    },

    /**
     * @param {string} section
     * @return {TiaraTracker}
     */
    setSection: function setSection(section) {
      this._section = section;
      return this;
    },

    /**
     * @param {string} page
     * @return {TiaraTracker}
     */
    setPage: function setPage(page) {
      this._page = page;
      return this;
    },

    /**
     * @param {Object} pageMeta
     * @return {TiaraTracker}
     */
    setPageMeta: function setPageMeta(pageMeta) {
      this._pageMeta = pageMeta;
      return this;
    },

    /**
     * @param {string} title
     * @return {TiaraTracker}
     */
    setTitle: function setTitle(title) {
      this._title = title;
      return this;
    },

    /**
     * @param {string} sessionTimeout
     * @return {TiaraTracker}
     */
    setSessionTimeout: function setSessionTimeout(sessionTimeout) {
      this._sessionTimeout = sessionTimeout;
      return this;
    },

    /**
     * @param {string} adTrackId
     * @return {TiaraTracker}
     */
    setAdTrackId: function setAdTrackId(adTrackId) {
      this._adTrackId = adTrackId;
      return this;
    },

    /**
     * @param {string} deployment
     * @return {TiaraTracker}
     */
    setDeployment: function setDeployment(deployment) {
      this._deployment = deployment;
      return this;
    },

    /**
     * @param {string} accessToken
     * @return {TiaraTracker}
     */
    setAccessToken: function setAccessToken(accessToken) {
      this._accessToken = accessToken;
      return this;
    },

    /**
     * @param {string} appUserId
     * @return {TiaraTracker}
     */
    setAppUserId: function setAppUserId(appUserId) {
      this._appUserId = appUserId;
      return this;
    },

    /**
     * @param {string} kakaoAppKey
     * @return {TiaraTracker}
     */
    setKakaoAppKey: function setKakaoAppKey(kakaoAppKey) {
      this._kakaoAppKey = kakaoAppKey;
      return this;
    },

    /**
     * @param {boolean} agree
     * @returns {TiaraTracker}
     */
    setThirdProvideAgree: function setThirdProvideAgree(agree) {
      if (typeof agree === 'boolean') {
        this._thirdProvideAgree = agree === true ? '1' : '0';
      }
      return this;
    },

    /**
     * @param {boolean} agree
     * @returns {TiaraTracker}
     */
    setThirdAdAgree: function setThirdAdAgree(agree) {
      if (typeof agree === 'boolean') {
        this._thirdAdAgree = agree === true ? '1' : '0';
      }
      return this;
    },

    /**
     * 추가 식별자 설정
     * @param {Object} account
     * @return {TiaraTracker}
     */
    userExAccount: function userExAccount(account) {
      this._userExAccount = account;
      return this;
    },

    /**
     * 추가 비식별자 설정
     * @param {Object} anonymous
     * @return {TiaraTracker}
     */
    userExAnonymous: function userExAnonymous(anonymous) {
      this._userExAnonymous = anonymous;
      return this;
    },

    /**
     * initialize common only
     * @param {Object} config
     * @return {TiaraTracker}
     */
    init: function init(config) {
      var svcDomain = config.svcDomain,
        adTrackId = config.adTrackId,
        enableAlwaysHttpPost = config.enableAlwaysHttpPost,
        enableAlwaysImage = config.enableAlwaysImage,
        disableSendLegacy = config.disableSendLegacy,
        enableHash = config.enableHash,
        sessionTimeout = config.sessionTimeout,
        disableQuery = config.disableQuery,
        ignoreQueryParams = config.ignoreQueryParams,
        trackDomain = config.trackDomain,
        deployment = config.deployment,
        autoClick = config.autoClick;

      this.setSvcDomain(svcDomain);
      this.setAdTrackId(adTrackId);
      this.setEnableAlwaysHttpPost(enableAlwaysHttpPost);
      this.setEnableAlwaysImage(enableAlwaysImage);
      this.setDisableSendLegacy(disableSendLegacy);
      this.setEnableHash(enableHash);
      this.setSessionTimeout(sessionTimeout);
      this.setDisableQuery(disableQuery);
      this.setIgnoreQueryParams(ignoreQueryParams);
      this.setTrackDomain(trackDomain);
      this.setDeployment(deployment);
      this.setAutoClick(autoClick);

      return this;
    },
  };

  var TiaraTrackerConfig = {
    /**
     * Http Post Method 강제 여부
     * @param {boolean} enable
     * @returns {TiaraTrackerCommon}
     */
    setEnableAlwaysHttpPost: function setEnableAlwaysHttpPost(enable) {
      this._enableAlwaysHttpPost = enable;
      return this;
    },

    /**
     * Image Method 강제 여부
     * @param {boolean} enable
     * @returns {TiaraTrackerCommon}
     */
    setEnableAlwaysImage: function setEnableAlwaysImage(enable) {
      this._enableAlwaysImage = enable;
      return this;
    },

    /**
     * 구티아라 전송 제외하고 싶을 때 사용
     * @param {boolean} disable
     * @returns {TiaraTrackerConfig}
     * @deprecated
     */
    setDisableSendLegacy: function setDisableSendLegacy(disable) {
      return this;
    },

    /**
     * url의 hash 값도 같이 수집하고자 할때 사용
     * @param {boolean} enableHash
     * @return {TiaraTracker}
     */
    setEnableHash: function setEnableHash(enableHash) {
      this._enableHash = enableHash;
      return this;
    },

    /**
     * url 에서 쿼리스트링 부분을 제외하고자 할때 사용
     * @param {boolean} disableQuery
     * @return {TiaraTracker}
     */
    setDisableQuery: function setDisableQuery(disableQuery) {
      this._disableQuery = disableQuery;
      return this;
    },

    /**
     * url 쿼리스트링에서 특정 파라미터를 제외하고자 할때 사용
     * @param {Array} ignoreQueryParams (for example, ['dummy', 'ts'])
     * @return {TiaraTracker}
     */
    setIgnoreQueryParams: function setIgnoreQueryParams(ignoreQueryParams) {
      this._ignoreQueryParams = ignoreQueryParams;
      return this;
    },

    /**
     * 전송하는 도메인을 변경하고자 할때 사용
     * 삼성브라우저인 경우는 도메인 변경 못하도록 함
     * @param {string} type kakao / daum 만 허용. 기타 값이 넘어온 경우 'daum' 으로 처리
     * @return {TiaraTracker}
     */
    setTrackDomain: function setTrackDomain(type) {
      if (isSamsungBrowser) {
        return this;
      }

      if (type) {
        if (type === 'kakao') {
          this._trackUrl = TRACK_URL_K;
        } else if (type === 'daum') {
          this._trackUrl = TRACK_URL_D;
        }
      }
      return this;
    },

    // url
    /**
     * hash, query param 처리
     * @param {string} url
     * @return {string}
     * @private
     */
    _process: function _process(url) {
      var processedUrl = url;
      if (!this._enableHash) {
        processedUrl = subString(processedUrl, '#');
      }

      if (this._disableQuery) {
        processedUrl = subString(processedUrl, '?');
      } else if (
        Array.isArray(this._ignoreQueryParams) &&
        this._ignoreQueryParams.length > 0
      ) {
        processedUrl = removeQueryParams(processedUrl, this._ignoreQueryParams);
      }

      return processedUrl;
    },

    /**
     * _process 를 통해 처리한 referrer
     * @return {string}
     * @private
     */
    _getReferrer: function _getReferrer() {
      return this._process(this._referrer);
    },

    /**
     * _process 를 통해 처리한 url
     * @return {string}
     * @private
     */
    _getUrl: function _getUrl() {
      return this._process(this._url); // todo 중복 실행 방지
    },
  };

  var ACTIONS = {
    action: 'action',
    bucket: 'bucket',
    custom_props: 'custom_props',
    section: 'section',
    page: 'page',
    click: 'click',
    event_meta: 'event_meta',
    search: 'search',
    ecommerce: 'ecommerce',
    ecommerce_contents: 'ecommerce_contents',
    usage: 'usage',
    viewimp_contents: 'viewimp_contents',
  };

  var TiaraTrackerAction = {
    // common
    /**
     * set action kind
     * @param {string} actionKind
     * @return {TiaraTracker}
     */
    actionKind: function actionKind(_actionKind) {
      this._actions._action.kind = _actionKind;
      return this;
    },

    /**
     * set page meta
     * @param {Object} pageMeta
     * @return {TiaraTracker}
     * @deprecated
     */
    pageMeta: function pageMeta(_pageMeta) {
      this._pageMeta = _pageMeta;
      return this;
    },

    /**
     * set bucket
     * @param {string} name
     * @param {string} group
     * @return {TiaraTracker}
     */
    bucket: function bucket(name, group) {
      this._actions._bucket = { name: name, group: group };
      return this;
    },

    /**
     * set abtest experiment
     * @param {Object} experiment
     * @return {TiaraTracker}
     */
    experiment: function experiment(_experiment) {
      this._actions._bucket = _experiment;
      return this;
    },

    /**
     * @param {Object} customProps
     * @return {TiaraTracker}
     */
    customProps: function customProps(_customProps) {
      this._actions._custom_props = _customProps;
      return this;
    },

    /**
     * @param {string} section
     * @return {TiaraTracker}
     */
    section: function section(_section) {
      this._actions._section = _section;
      return this;
    },

    /**
     * @param {string} page_
     * @return {TiaraTracker}
     */
    page: function page(page_) {
      this._actions._page = page_;
      return this;
    },

    // page
    /**
     * @param {string} action
     * @return {TiaraTracker}
     */
    trackPage: function trackPage(action) {
      this._actions._action = {
        type: 'Pageview',
        name: action,
        kind: '',
      };

      this._elements = [
        ACTIONS.action,
        ACTIONS.search,
        ACTIONS.ecommerce,
        ACTIONS.ecommerce_contents,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];

      return this;
    },

    // event
    /**
     * @param {string} action
     * @return {TiaraTracker}
     */
    trackEvent: function trackEvent(action) {
      this._actions._action = {
        type: 'Event',
        name: action,
        kind: '',
      };
      this._elements = [
        ACTIONS.action,
        ACTIONS.click,
        ACTIONS.search,
        ACTIONS.event_meta,
        ACTIONS.ecommerce,
        ACTIONS.ecommerce_contents,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];
      return this;
    },

    /**
     * @param {Object} click_
     * @return {TiaraTracker}
     */
    click: function click(click_) {
      this._actions._click = click_;
      return this;
    },

    /**
     * @param {Object} eventMeta_
     * @return {TiaraTracker}
     */
    eventMeta: function eventMeta(eventMeta_) {
      this._actions._event_meta = eventMeta_;
      return this;
    },

    /**
     * @param {Object} search_
     * @return {TiaraTracker}
     */
    search: function search(search_) {
      this._actions._search = search_;
      return this;
    },

    // ecommerce
    /**
     * @param {string} action
     * @return {TiaraTracker}
     */
    trackEcommerce: function trackEcommerce(action) {
      this._actions._action = {
        type: 'Ecommerce',
        name: action,
        kind: '',
      };

      this._elements = [
        ACTIONS.action,
        ACTIONS.search,
        ACTIONS.ecommerce,
        ACTIONS.ecommerce_contents,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];

      return this;
    },

    /**
     * @param {Object} ecommerce_
     * @return {TiaraTracker}
     */
    ecommerce: function ecommerce(ecommerce_) {
      this._actions._ecommerce = ecommerce_;
      return this;
    },

    /**
     * @param {Array} ecommerceContents_
     * @return {TiaraTracker}
     */
    ecommerceContents: function ecommerceContents(ecommerceContents_) {
      this._actions._ecommerce_contents = ecommerceContents_;
      return this;
    },

    // usage
    /**
     * @return {TiaraTracker}
     */
    trackUsage: function trackUsage() {
      this._actions._action = {
        type: 'Usage',
        name: null,
        kind: 'UsagePage',
      };

      this._elements = [
        ACTIONS.action,
        ACTIONS.usage,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];

      return this;
    },

    /**
     * @param {Object} usage_
     * @return {TiaraTracker}
     */
    usage: function usage(usage_) {
      this._actions._usage = usage_;
      return this;
    },

    /**
     * @return {TiaraTracker}
     */
    trackViewImp: function trackViewImp() {
      this._actions._action = {
        type: 'ViewImp',
        name: null,
        kind: null,
      };

      this._elements = [
        ACTIONS.action,
        ACTIONS.viewimp_contents,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];

      return this;
    },

    /**
     * @param {Object} viewImpContents_
     * @return {TiaraTracker}
     */
    viewImpContents: function viewImpContents(viewImpContents_) {
      this._actions._viewimp_contents = viewImpContents_;
      return this;
    },

    /**
     * extra
     * @param {string} action
     * @return {TiaraTracker}
     */
    trackExtra: function trackExtra(action) {
      this._actions._action = {
        type: 'Extra',
        name: action,
        kind: '',
      };
      this._elements = [
        ACTIONS.action,
        ACTIONS.click,
        ACTIONS.search,
        ACTIONS.event_meta,
        ACTIONS.ecommerce,
        ACTIONS.ecommerce_contents,
        ACTIONS.bucket,
        ACTIONS.custom_props,
      ];
      return this;
    },
  };

  var COOKIE_MONSTER_VERSION = '0.0.1',
    COOKIE_MONSTER_URL = [
      'https://webid.ad.daum.net',
      '/sync',
      '?v=',
      COOKIE_MONSTER_VERSION,
    ].join(''),
    WEBID_SYNC_COOKIE_NAME = 'webid_sync',
    WEBID_SYNC_DURATION_SECS = 10;

  /**
   * Cookie sync가 필요한가? (서버에도 동일한 로직이 있음)
   * wedid_sync cookie는 마지막으로 동기화 한 timestamp를 가지고 있음
   * now < ts || (ts + durationSecs) < now 이면 동기화가 필요
   * @param latestSyncTimeMs
   * @param nowMs
   * @param durationSecs
   * @returns {boolean}
   * @private
   */
  function isNeedCookieSync(latestSyncTimeMs, nowMs, durationSecs) {
    return nowMs < latestSyncTimeMs ||
      latestSyncTimeMs + durationSecs * 1000 < nowMs
      ? true
      : false;
  }

  var CookieMonster = {
    /**
     * duration 내에 다시 호출한 경우는 무시하고 그 외엔 모두 sync
     * @returns {boolean}
     */
    sync: function sync() {
      var result = true;
      var webIdSync = getCookie(WEBID_SYNC_COOKIE_NAME);
      if (
        isNumeric(webIdSync) &&
        !isNeedCookieSync(
          new Number(webIdSync).valueOf(),
          new Date().getTime(),
          WEBID_SYNC_DURATION_SECS,
        )
      ) {
        result = false;
      }
      if (result) {
        imageRequest(COOKIE_MONSTER_URL);
      }
      return result;
    },
  };

  /**
   * 이벤트 리스너 추가
   * @param {EventTarget} target 이벤트 대상
   * @param {string} type 이벤트 종류
   * @param {function} listener 이벤트 콜백
   * @param {boolean} capture 캡쳐 여부
   */
  function addEvent(target, type, listener) {
    var capture =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!target) {
      return;
    }
    if (target.addEventListener) {
      target.addEventListener(type, listener, !!capture);
    } else {
      // for ie < 9
      target.attachEvent('on' + type, listener);
    }
  }

  /**
   * 이벤트 리스너 제거
   * @param {EventTarget} target 이벤트 대상
   * @param {string} type 이벤트 종류
   * @param {function} listener 이벤트 콜백
   * @param {boolean} capture 캡쳐 여부
   */
  function removeEvent(target, type, listener) {
    var capture =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!target) {
      return;
    }
    if (target.removeEventListener) {
      target.removeEventListener(type, listener, !!capture);
    } else {
      // for ie < 9
      target.detachEvent('on' + type, listener);
    }
  }

  /**
   * 자동 클릭이 설정되어있고, 클릭 이벤트 발생 시 호출 (action.name은 필수값이므로 반드시 있어야 함)
   * 액션과 클릭 정보 수집 후, 로그 전송
   * @this {TiaraTracker}
   * @param {Event} event
   */
  function sendAutoClickInfo(event) {
    var autoClickInfo = TiaraDomParser.getClickInfo(event);

    if (
      autoClickInfo &&
      autoClickInfo.action &&
      typeof autoClickInfo.action.name === 'string'
    ) {
      var action = autoClickInfo.action,
        click = autoClickInfo.click,
        search = autoClickInfo.search,
        eventMeta = autoClickInfo.eventMeta,
        customProps = autoClickInfo.customProps;

      // data-tiara 항목 정보 설정

      this.trackEvent(action.name);
      this.actionKind(action.kind);

      // 클릭 정보 세팅, 전송
      this.click(click);
      this.search(search);
      this.eventMeta(eventMeta);
      this.customProps(customProps);
      this.track();
    }
  }

  var TiaraTrackerAuto = {
    /**
     * 자동 클릭 설정
     * @param {boolean} auto 자동 클릭 설정 여부
     * @return {TiaraTracker}
     */
    setAutoClick: function setAutoClick(auto) {
      var _this = this;

      if (typeof this._onAutoClick === 'function') {
        removeEvent(document, 'mousedown', this._onAutoClick, false);
      }
      if (auto) {
        this._onAutoClick = function (e) {
          return sendAutoClickInfo.call(_this, e);
        };
        addEvent(document, 'mousedown', this._onAutoClick, false);
      }
      return this;
    },
  };

  /* global window */

  var tiaraTrackerInstance = null;

  function TiaraTracker() {
    // common
    this._svcdomain = cookieEnabled
      ? window.document.location.hostname
      : 'cookie.disabled'; // 세팅을 안한 경우 기본적으로 현재 도메인을 그대로 들어갑니다.
    this._url = window.document.location.href;
    this._referrer = window.document.referrer;
    this._section = '';
    this._page = ''; // required
    this._title = defaults.title;
    this._sessionTimeout = defaults.sessionTimeout;
    this._adTrackId = '';
    this._deployment = defaults.deployment;
    this._accessToken = '';
    this._appUserId = '';
    this._kakaoAppKey = '';
    this._pageMeta = null;
    this._thirdProvideAgree = null;
    this._thirdAdAgree = null;
    this._userExAccount = null;
    this._userExAnonymous = null;

    // action
    this._actionInit();

    // config
    this._enableAlwaysHttpPost = false;
    this._enableAlwaysImage = false;
    this._enableHash = false;
    this._disableQuery = false;
    this._ignoreQueryParams = null;
    this._trackUrl = defaults.trackUrl;

    /**
     * action을 setting 했을때 사용할 요소
     * @type {Array}
     */
    this._elements = null;

    /**
     * tuid/tsid & uuid/suid
     */
    this._tuid = IDGenerator.generateRandomUUIDWithDateTime();
    this._tsid = this._tuid;
    this._uuid = IDGenerator.generateRandomUUIDWithDateNumber();
    this._suid = this._uuid;
  }

  /**
   * get click/eventMeta information on click
   * @param event
   * @returns {*|{click, eventMeta}}
   */
  TiaraTracker.getClickInfo = function getClickInfo(event) {
    return TiaraDomParser.getClickInfo(event);
  };

  /**
   * get tiara tracker instance
   * @return {TiaraTracker}
   */
  TiaraTracker.getInstance = function getInstance() {
    if (!tiaraTrackerInstance) {
      tiaraTrackerInstance = new TiaraTracker();
    }

    return tiaraTrackerInstance;
  };

  /**
   * init tiara tracker instance
   */
  TiaraTracker.initTracker = function initTracker() {
    tiaraTrackerInstance = new TiaraTracker();
  };

  TiaraTracker.prototype = {
    /**
     * actions 초기화
     * constructor, track 메소드에서 사용
     * @private
     */
    _actionInit: function _actionInit() {
      this._actions = {
        // common
        _action: null,
        _bucket: null,
        _custom_props: null,

        // event
        _click: null,
        _event_meta: null,

        // search
        _search: null,

        // ecommerce
        _ecommerce: null,
        _ecommerce_contents: null,

        // usage
        _usage: null,

        // view
        _viewimp_contents: null,
      };
    },

    /**
     * get common property
     * @param {string} propertyName
     * @return {*}
     * @private
     */
    _getProperty: function _getProperty(propertyName) {
      if (propertyName === 'referrer') {
        return this._getReferrer();
      }
      if (propertyName === 'url') {
        return this._getUrl();
      }

      var prop = this['_' + propertyName];

      return prop;
    },

    /**
     * get action property
     * @param {string} propertyName
     * @return {*}
     * @private
     */
    _getActionProperty: function _getActionProperty(propertyName) {
      var prop = this._actions['_' + propertyName];
      return prop;
    },

    /**
     * 너무 길게 들어오는 데이터를 잘라내는 로직
     * @param tiara
     * @private
     */
    _truncateData: function _truncateData(property, maxLength) {
      if (property && property.length > maxLength) {
        return property.substring(0, maxLength);
      }
      return property;
    },

    /**
     * 전송전에 필요한 로직
     * @private
     */
    _processBeforeSend: function _processBeforeSend() {
      var maxUrlLength = 1024,
        maxCopyLength = 256;
      this._url = this._truncateData(this._url, maxUrlLength);
      this._referrer = this._truncateData(this._referrer, maxUrlLength);

      if (this._actions._click) {
        this._actions._click.click_url = this._truncateData(
          this._actions._click.click_url,
          maxUrlLength,
        );
        this._actions._click.copy = this._truncateData(
          this._actions._click.copy,
          maxCopyLength,
        );
      }
    },

    /**
     * send
     */
    track: function track() {
      this._processBeforeSend();

      Requester.send(this);

      // init
      this._actionInit();
    },
  };

  // tiara tracker common
  mixin(TiaraTracker.prototype, TiaraTrackerCommon);
  // tiara tracker config
  mixin(TiaraTracker.prototype, TiaraTrackerConfig);
  // tiara tracker action
  mixin(TiaraTracker.prototype, TiaraTrackerAction);
  // tiara tracker auto
  mixin(TiaraTracker.prototype, TiaraTrackerAuto);

  setTimeout(function () {
    try {
      CookieMonster.sync();
    } catch (e) {}
  }, 500);

  return TiaraTracker;
})();

// for kakaowebtoon
window.TiaraTracker = TiaraTracker;
